import { h, Component } from "preact";
import { connect } from "react-redux";
import { css } from "emotion";

import { loadScripts, checkout } from "../../state/actions/zipMoneyActions";
import { payClicked } from "../../state/actions/orderActions";

import Image from "../../components/Image";
import Note from "../../components/Note";

import logoZipPay from "../../assets/images/icon-zip2.png";

import config from "../../config";

const zipImageStyling = css({
  margin: "-6px 6px 0 12px",
  height: 34
});

class ZipMoney extends Component {
  constructor() {
    super();

    this.checkout = this.checkout.bind(this);
  }

  componentDidMount() {
    const { zipMoney, loadScripts } = this.props;
    if (!zipMoney.scripts.loaded && !zipMoney.scripts.loading) {
      loadScripts();
    }
  }

  checkout() {
    const { checkout, order, event, payClicked } = this.props;
    const orderId = order.data._id;
    payClicked();
    checkout(event.data.slug, orderId);
  }

  render() {
    const { zipMoney, order, orderSummary, event } = this.props;
    const WEBSITE_URL = config("WEBSITE_URL");
    const styles = {
      display: "flex",
      padding: "0px"
    };
    // Remove ZIP pay temporarily while we await a fix
    if (!event || !event.data || !event.data.paymentOptions.zipMoneyEnabled) {
      return null;
    }

    if (orderSummary && orderSummary.data && orderSummary.data.total > 1500) {
      return <Note>zipPay can only be used for orders under $1500</Note>;
    }

    const loading =
      (!zipMoney.scripts.loaded && zipMoney.scripts.loading) ||
      zipMoney.checkout.loading ||
      order.paymentRequest.loading ||
      order.waitingToPay
        ? true
        : false;

    return (
      <div class="form-group">
        <label for="form-label" class="form-label">
          Or Pay with zipPay
        </label>
        <div>
          <button
            type="button"
            className="btn btn-simple"
            id="zip-checkout"
            disabled={loading || order.timeExpired}
            onClick={() => {
              if (loading) {
                return;
              }
              this.checkout();
            }}
            aria-label="Checkout"
          >
            <div style={styles}>
              <Image className={zipImageStyling} alt="Zip" src={logoZipPay} />
              <span
                style={{
                  padding: "0 12px 0px 6px",
                  borderLeft: "1px solid #e7e7e7"
                }}
              >
                {loading ? (
                  <div
                    class="loading"
                    style={{
                      margin: "2px 0 0 12px"
                    }}
                  />
                ) : (
                  "Own it now, pay later"
                )}
              </span>
            </div>
          </button>
        </div>
        <a
          href={`${WEBSITE_URL}/zipmoney`}
          style={{ fontSize: 14 }}
          target="_blank"
        >
          Learn More
        </a>
      </div>
    );
  }
}

export default connect(
  (state, ownProps) => ({
    event: state.event,
    order: state.order,
    zipMoney: state.zipMoney,
    orderSummary: state.orderSummary,
    seatingMap: state.seatingMap
  }),
  {
    loadScripts,
    checkout,
    payClicked
  }
)(ZipMoney);



// WEBPACK FOOTER //
// ./routes/payment/ZipMoney.js